import { getSVG } from './components/icons-loader.js';

document.addEventListener("DOMContentLoaded", function () {
  loadYouTubeVideos();
  getSVG();
});

const htmlTag = document.querySelector('html');

function loadYouTubeVideos() {
  const playerButton = document.querySelectorAll('.play-button');
  const playerStage = document.querySelector('#videoPlayerStage');

  if (playerButton.length) {
    playerButton.forEach(element => {
      const videoTarget = element.getAttribute('data-video-scr');
      element.addEventListener('click', () => {
        playerStage.innerHTML = `<iframe width="560" height="315" class="video-player-container playerIntro"
          src="${videoTarget}"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>`;
        document.querySelector('#videoPlayerStage').classList.toggle('active');
        htmlTag.classList.toggle('no-scroll');

      })
    });

    playerStage.addEventListener('click', function () {
      this.classList.remove('active');
      playerStage.querySelectorAll('.video-player-container')[0].remove();
      htmlTag.classList.toggle('no-scroll');
    });
  }
}
